import {Button, Paper} from '@material-ui/core';
import {Async, Loaded} from 'Core/models/Async';
import {eqPhoneNumber, PhoneNumber, ValidPhoneNumber} from 'Core/models/PhoneNumber';
import {Either, fold, isRight, left, right} from 'fp-ts/lib/Either';
import {identity} from 'fp-ts/lib/function';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useState} from 'react';
import PhoneInput from 'Shared/components/PhoneInput';
import withSelectedAgency, {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import {saveMobilePhone} from 'Users/ducks/userAccount';

type UserEmailSectionProps = {
  userId: string;
  phoneEither: Either<PhoneNumber, PhoneNumber>;
  onChange: (phone: Async<Either<PhoneNumber, PhoneNumber>>) => void;
  saveMobilePhone: typeof saveMobilePhone;
} & WithSelectedAgencyProps;

const UserMobilePhoneSection = (props: UserEmailSectionProps) => {
  const {selectedAgency} = props;
  const mobilePhone = pipe(props.phoneEither, fold(identity, identity));
  const [originalMobilePhone] = useState(mobilePhone);
  const isEditing = isRight(props.phoneEither);
  const hasMobilePhoneChanged = !eqPhoneNumber.equals(originalMobilePhone, mobilePhone);
  return (
    <Paper className="user-profile__user-info-section">
      <div className="user-info-section__header">
        <h3>Mobile Phone</h3>
      </div>
      <div className="user-info-section__name-fields">
        <PhoneInput
          className="user-info-section__profile-input"
          label="Mobile Phone"
          disabled={!isEditing}
          onChange={newMobilePhone => props.onChange(new Loaded(right(newMobilePhone)))}
          phoneNumber={mobilePhone}
        />
      </div>
      <div className="user-info-section__actions-container">
        {isEditing ? (
          <>
            <Button
              variant="contained"
              className="user-info-section__cancel-user-information-button"
              onClick={() => {
                props.onChange(new Loaded(left(originalMobilePhone)));
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!hasMobilePhoneChanged || !(mobilePhone instanceof ValidPhoneNumber)}
              color="primary"
              variant="contained"
              className="user-info-section__save-user-information-button"
              onClick={() =>
                props.saveMobilePhone(
                  props.userId,
                  mobilePhone as ValidPhoneNumber,
                  selectedAgency?.encryptedIdentifier
                )
              }
            >
              Save
            </Button>
          </>
        ) : (
          <Button
            className="user-info-section__edit-button"
            color="primary"
            variant="contained"
            onClick={() => props.onChange(new Loaded(right(mobilePhone)))}
          >
            Edit&nbsp;&nbsp;
            <i className="fa fa-edit" />
          </Button>
        )}
      </div>
    </Paper>
  );
};

export default withSelectedAgency(UserMobilePhoneSection);
